import React, { createContext, useContext, useState, useEffect } from 'react';
import { loginUser, updatePassword } from '../logic/authLogic';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]                           = useState(null);
  const [loading, setLoading]                     = useState(true);
  const [mustChangePassword, setMustChangePassword] = useState(false);

  useEffect(() => {
    const token  = localStorage.getItem('token');
    const stored = localStorage.getItem('user');
    if (token && stored && stored !== 'undefined') {
      try {
        const parsed = JSON.parse(stored);
        setUser(parsed);
        setMustChangePassword(!!parsed.must_change_password);
      } catch (e) {
        console.error('Failed to parse stored user:', e);
        localStorage.removeItem('user');
        localStorage.removeItem('token');
      }
    }
    setLoading(false);
  }, []);

  const login = async (username, password, company_id) => {
    const { token, user, branding } = await loginUser(username, password, company_id);
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    if (branding) {
      localStorage.setItem('branding', JSON.stringify(branding));
    }
    setUser(user);
    setMustChangePassword(!!user.must_change_password);
    return { token, user, branding };
  };

  const logout = () => {
    localStorage.clear();
    setUser(null);
    setMustChangePassword(false);
  };

  const changePassword = async (currentPassword, newPassword) => {
    await updatePassword(currentPassword, newPassword);
    const updatedUser = { ...user, must_change_password: false };
    localStorage.setItem('user', JSON.stringify(updatedUser));
    setUser(updatedUser);
    setMustChangePassword(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, mustChangePassword, changePassword }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
